import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, Typography, CircularProgress } from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    }
});

const ApiKeyForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="ApiKey"
                                value={values.ApiKey}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ApiKey && touched.ApiKey)}
                                placeholder={translations["api_key"] || "ApiKey"}
                                label={translations["api_key"] || "ApiKey"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {(isSubmitting) ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles)(ApiKeyForm);
